import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TakeawayFilters } from 'components';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  toggleTakeawayFilter,
  setUnmappedProductDetailsOffices,
} from 'store/ProductDetails/delivery/actions';
import { getDeliveryTakeawayFiltersToShow } from 'store/ProductDetails/selectors';

function TakeawayViewFilters({ isMobile, filters, onChangeFilter, setOffices }) {
  useEffect(() => {
    setOffices();
  }, []);
  return <TakeawayFilters filters={filters} {...{ isMobile, onChangeFilter }} />;
}

TakeawayViewFilters.propTypes = {
  isMobile: PropTypes.bool,
  onChangeFilter: PropTypes.func,
  setOffices: PropTypes.func,
  filters: PropTypes.array,
};

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow800(state),
  filters: getDeliveryTakeawayFiltersToShow(state),
});

const mapDispatchToProps = {
  onChangeFilter: toggleTakeawayFilter,
  setOffices: setUnmappedProductDetailsOffices,
};

export default connect(mapStateToProps, mapDispatchToProps)(TakeawayViewFilters);
